








































































































































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import CustomForm from '@/components/custom-form/index.vue'
import Ajax from '@/lib/ajax'
import axios from 'axios'
import AbpBase from '@/lib/abpbase'
import appconst from '@/lib/appconst'
import tokenCofig from '@/lib/tokenCofig'
import ViewUI from 'view-design'
@Component({
  components: {
    CustomForm,
  },
})
export default class DefaultTable extends AbpBase {
  loading: boolean = false
  isCheckAll = false
  tableData: any[] = []
  config: any = {}
  modal1: boolean = false
  pageCoupon = {
    totalCount: 0,
    maxResultCount: 10,
    currentPage: 1,
    skipCount: 0,
  }
  IsMultiple: boolean = true
  btnText: string = '选择优惠码'
  couponRow: any = {}
  data = []
  page = {
    totalCount: 0,
    currentPage: 1,
    skipCount: 0,
    maxResultCount: 10,
  }

  filtersCoupon = [
    {
      label: '输入搜索：',
      type: 'input',
      props: {
        placeholder: '请输入优惠码',
      },
      key: 'Code',
    },
    {
      label: '使用情况：',
      type: 'select',
      props: {
        placeholder: '请选择',
      },
      key: 'Status',
      options: [
        {
          text: '未使用',
          value: 0,
        },
        {
          text: '已使用',
          value: 2,
        },
        {
          text: '已过期',
          value: 3,
        },
      ],
    },
  ]
  // TODO
  columnsCoupon = [
    {
      title: '优惠券码',
      key: 'code',
      align: 'center',
    },
    {
      title: '使用状态',
      key: 'statusStr',
      align: 'center',
    },
  ]

  get filters() {
    return this.config.filters || []
  }
  get columns() {
    return this.config.columns || []
  }
  get showPage() {
    return this.config.showPage != null ? this.config.showPage : true
  }
  get tableHeadButtons() {
    return this.config.tableHeadButtons || []
  }
  get tableFootButtons() {
    return this.config.tableFootButtons || []
  }
  get tableCouponButtons() {
    return this.config.tableCouponButtons || []
  }
  get tableActionButtons() {
    return this.config.tableActionButtons || []
  }
  get tableSlot() {
    let list = []
    if (this.config.columns) {
      list = this.config.columns.filter((item) => item.slot)
    }
    return list
  }

  get showSelectAll() {
    return this.config.columns.some((item) => item.type == 'selection')
  }

  submitFn() {
    if (this.filters.length > 0) {
      let form: any = this.$refs.lineForm
      form.submit()
    } else {
      this.getData()
    }
  }

  onSubmit(form, valid) {
    if (valid) {
      console.log(form, valid)
      this.getData(form)
    } else {
      console.log(form, valid)
      this.$Message.error('验证失败')
    }
  }
  changePage(e) {
    this.page.currentPage = e
    this.page.skipCount = this.page.currentPage <= 1 ? 0 : (this.page.currentPage - 1) * this.page.maxResultCount
    this.submitFn()
  }
  pageSizeChange(e) {
    this.page.maxResultCount = e
    this.submitFn()
  }

  mounted() {}

  @Watch('$route', {
    immediate: true,
  })
  routeWatch() {
    let query: any = this.$route.query
    for (let key in this.$route.query) {
      try {
        this.page[key] = JSON.parse(query[key])
      } catch (error) {
        this.page[key] = query[key]
      }
      // this.page[key] = JSON.parse(query[key])
    }
    ViewUI['LoadingBar'].finish()
    this.init()
  }

  /**
   * 获取表单配置信息
   */
  init() {
    axios.get(`${appconst.appBaseUrl}/${this.$route.meta.jsonUrl}.json`).then((res) => {
      console.log('defaultTable', res)
      if (res.data) {
        this.config = res.data
        this.getData()

        if (this.config.filterData) {
          this.config.filterData.forEach((item) => {
            if (item.filed) {
              this.getFilterData(item)
            }
          })
        }
      }
    })
  }

  /**
   * 获取表单数据
   */
  getFilterData(params) {
    let obj = {}

    for (let key in params.params) {
      obj[key] = this.page[key]
    }

    Ajax[params.axiosType](params.url, { params: obj })
      .then((res) => {
        if (res.data) {
          this.config.filters.forEach((item) => {
            if (item.key == params.filed) {
              switch (item.type) {
                case 'select':
                  item.options = [
                    {
                      value: 0,
                      text: '标卡1',
                    },
                    {
                      value: 1,
                      text: '银卡2',
                    },
                    {
                      value: 2,
                      text: '金卡3',
                    },
                    {
                      value: 3,
                      text: '白金卡4',
                    },
                  ]
                  break
              }
            }
          })
        }
      })
      .catch((err) => {})
  }

  /**
   * 获取分页列表
   */
  getData(form?) {
    let { page } = this
    this.loading = true
    let { getData } = this.config
    let obj = {}

    for (let key in getData.params) {
      obj[key] = this.page[key]
    }
    if (getData.extra) {
      Object.keys(getData.extra).forEach((item) => {
        getData.extra[item].forEach((innerItem) => {
          if (item === 'routerParams') {
            obj[innerItem] = this.$route.params[innerItem]
          }
          if (item === 'routerQuery') {
            obj[innerItem] = this.$route.query[innerItem]
          }
        })
      })
    }
    let params = form ? Object.assign({}, form, obj) : Object.assign({}, obj)

    Ajax[getData.axiosType](getData.url, { params: params })
      .then((res) => {
        this.loading = false
        if (res.data) {
          this.tableData = res.data.items
          page.totalCount = res.data.totalCount
        }
      })
      .catch((err) => {
        this.loading = false
      })
  }

  /**
   * 列表全选
   */
  handleSelectAll() {
    if (!this.tableData.length) return
    ;(this.$refs.selection as any).selectAll(!this.isCheckAll)
  }

  handleTableAllCancel() {
    this.isCheckAll = false
  }

  handleTableAll() {
    this.isCheckAll = true
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }

  // 调用组件外的方法
  emitFn(item, listRow?) {
    this.$emit(item.emitName, listRow || null)
  }
  // //copy方法
  // copy(item, listRow?) {
  //    this.$emit(item.emitName, listRow || null)
  // }
  /**
   * 页面跳转
   */
  goToFn(item, row?) {
    if (item.script) {
      var fun = eval(item.script)
      if (fun()) {
        return
      }
    }
    let rule = item.rule || {}
    let query = {}
    if (item.click && item.click != 'goToFn') {
      this[item.click](item, row)
      return
    }
    if (row) {
      let params = rule.paramsName == 'all' ? row : row[rule.paramsName]
      query[rule.paramsName] = params
    }
    if (rule.queryName) {
      rule.queryName.forEach((element) => {
        query[element.key] = this.$route.query[element.value]
      })
    }
    this.$router.push({
      name: rule.routeName,
      query: query,
    })
  }
  batchReview(item) {
    let selection = (this.$refs.selection as any).getSelection()
    console.log(selection)
    if (selection.length) {
      this.$Modal.confirm({
        title: '提示',
        content: `确认全部审核已选中活动？`,
        onOk: () => {
          // this.loading = true
          let list: any = selection.map((item) => {
            return item.id
          })
          let rule = item.rule
          let url = `${rule.url}`
          Ajax[rule.axiosType](url, list)
            .then((res) => {
              if (rule.isrefresh) {
                this.getData()
              }
            })
            .catch((err) => {})
        },
      })
    } else {
      this.$Notice.warning({
        title: '请先选择活动',
      })
    }
  }
  /**
   * 查看优惠码
   */
  viewCoupon(item, row?) {
    console.log(item, row)
    this.modal1 = true
    this.couponRow = row
    this.getCouonData(row)
  }
  cancel() {
    this.modal1 = false
  }
  submitChange(form, valid) {
    console.log(form)
    this.pageCoupon.skipCount = 0
    this.getCouonData(this.couponRow, form)
  }
  currentChange(currentRow, oldCurrentRow) {
    // if (!this.IsMultiple) {
    //   this.$emit('on-row-selected', currentRow.id)
    //   this.modal1 = false
    // }
  }
  onPageChange(e) {
    console.log(e)
    this.pageCoupon.currentPage = e
    this.pageCoupon.skipCount =
      this.pageCoupon.currentPage <= 1 ? 0 : (this.pageCoupon.currentPage - 1) * this.pageCoupon.maxResultCount
    let form: any = this.$refs.lineFormCoupon
    console.log(form.form)
    this.getCouonData(this.couponRow, form.form)
  }
  getCouonData(row, form?) {
    let { pageCoupon } = this
    this.loading = true
    let { getCouponData } = this.config
    let obj = {
      id: row.id,
    }

    for (let key in getCouponData.params) {
      obj[key] = this.pageCoupon[key]
    }
    console.log(obj)
    let params = form ? Object.assign({}, form, obj) : Object.assign({}, obj)
    console.log(params)
    Ajax[getCouponData.axiosType](getCouponData.url, { params: params })
      .then((res) => {
        console.log(res)
        this.loading = false
        if (res.data) {
          this.data = res.data.items
          this.pageCoupon.totalCount = res.data.totalCount
        }
      })
      .catch((err) => {
        this.loading = false
      })
  }

  /**
   * 导出优惠码
   */
  exportCoupon(item, row?) {
    console.log('导出优惠码', row)
    let refForm: any = this.$refs.lineFormCoupon
    const form = refForm.getForm()
    console.log(form)
    let { exportCouponData } = this.config
    Ajax[exportCouponData.axiosType](exportCouponData.url, {
      params: { id: row.id },
      responseType: 'blob',
    })
      .then((res) => {
        console.log(res)
        this.download(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }
  download(data) {
    if (!data) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', '优惠券券码.xlsx')

    document.body.appendChild(link)
    link.click()
  }

  /**
   * 导出报表
   */
  exportCouponReport(item) {
    console.log(item)
    Ajax[item.rule.axiosType](item.rule.url, {
      responseType: 'blob',
    })
      .then((res) => {
        console.log(res)
        this.downloadCouponReport(res.data, item.rule.name)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  downloadCouponReport(data, name) {
    if (!data) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', `${name}.xlsx`)

    document.body.appendChild(link)
    link.click()
  }

  /**
   * 删除行
   */
  deleteRow(item, row: any) {
    console.log('deleteRow')
    let rule = item.rule
    let url = `${rule.url}/${row[rule.paramsName]}`
    if (rule.postFiled) {
      url = `${rule.url}?${rule.postFiled}=${row[rule.paramsName]}`
    }
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.loading = true
        Ajax[rule.axiosType || 'delete'](url)
          .then((res) => {
            this.loading = false
            this.getData()
          })
          .catch((err) => {
            this.loading = false
          })
      },
    })
  }

  /**
   * 复制行
   */
  copyRow(item, row: any) {
    console.log('copyRow')
    console.log(item, row)
    let rule = item.rule
    let url = `${rule.url}?id=${row[rule.paramsName]}`
    if(rule.text) {
      url = `${rule.url}/${row[rule.paramsName]}`
    }

    this.$Modal.confirm({
      title: '提示',
      content: `确定要复制此${rule.text ? rule.text : '模板'}吗??`,
      onOk: () => {
        this.loading = true
        Ajax[rule.axiosType || 'delete'](url)
          .then((res) => {
            this.loading = false
            this.getData()
          })
          .catch((err) => {
            this.loading = false
          })
      },
    })
  }

  /**
   * 表格多选事件
   */
  selectionFn(item: any = {}) {
    let rule = item.rule || {}
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      let list = rule.paramsName == 'all' ? selection : selection.map((item) => item[rule.paramsName])
      let query = {}
      query[rule.paramsName] = JSON.stringify(list)
      this.$router.push({
        name: rule.routeName,
        query: query,
      })
    } else {
      this.$Notice.warning({
        title: rule.clickTips || '请先选择数据',
      })
    }
  }

  /**
   * 批量删除
   */
  deleteSelectFn(item) {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      console.log('执行删除')
      this.$Modal.confirm({
        title: '批量删除',
        content: `是否删除已选中?`,
        onOk: () => {
          this.loading = true
          let rule = item.rule
          let list = []
          selection.forEach((child) => {
            let obj = {}
            obj[rule.postFiled || rule.paramsName] = child[rule.paramsName]
            list.push(obj)
          })

          let params = '?'
          list.forEach((result, index) => {
            params += (rule.postFiled || rule.paramsName) + '=' + result[rule.postFiled || rule.paramsName]
            if (index < list.length - 1) {
              params += '&'
            }
          })
          Ajax[rule.axiosType || 'delete'](rule.url + params)
            .then((res) => {
              this.loading = false
              this.getData()
            })
            .catch((err) => {
              this.loading = false
            })
        },
      })
    } else {
      this.$Notice.warning({
        title: '请先选择数据',
      })
    }
  }

  /**
   * switch开关
   */
  switchChange(event, row, item) {
    let rule = item.rule
    let url = `${rule.url}/${row[rule.paramsName]}`
    if (rule.postFiled) {
      url = `${rule.url}?${rule.postFiled}=${row[rule.paramsName]}`
    }
    Ajax[rule.axiosType](url)
      .then((res) => {
        if (rule.isrefresh) {
          this.getData()
        }
      })
      .catch((err) => {})
  }

  /**
   * 导出
   */
  exportFn() {
    console.log('导出了')
  }
}
